/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFocus = createReactComponent("focus", "IconFocus", [
  [
    "circle",
    { cx: "12", cy: "12", r: ".5", fill: "currentColor", key: "svg-0" }
  ],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }]
]);

export { IconFocus as default };
//# sourceMappingURL=IconFocus.js.map
